const getFaviconSize = favicon => {
  const sizeAttribute = favicon.getAttribute('sizes');
  if (!sizeAttribute) {
    return '32x32';
  }
  return sizeAttribute.split(' ')[0];
};

const cacheDefaultHref = favicon => {
  if (!favicon.dataset.defaultHref) {
    favicon.dataset.defaultHref = favicon.href;
  }
};

const getFavicons = () => {
  const favicons = document.querySelectorAll('.favicon');
  favicons.forEach(cacheDefaultHref);
  return favicons;
};

export const showBadgeOnFavicon = () => {
  const favicons = getFavicons();

  favicons.forEach(favicon => {
    const [preferredSize] = getFaviconSize(favicon).split('x');
    const newFileName = `/favicon-badge-${preferredSize}x${preferredSize}.png`;
    favicon.href = newFileName;
  });
};

export const initFaviconSwitcher = () => {
  const favicons = getFavicons();

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      favicons.forEach(favicon => {
        const { defaultHref } = favicon.dataset;
        if (defaultHref) {
          favicon.href = defaultHref;
        }
      });
    }
  });
};
